import { useCallback } from 'react';

import { useMenuContext } from 'applications/GSP/pages/ParentHelper/components/History/hooks';
import { useParentHelperContext } from 'applications/GSP/pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { sortChatsByDateAndFavorite } from 'applications/GSP/pages/ParentHelper/utils';
import { usePutApiParentHelperTopicsFavouriteMutation } from 'applications/GSP/shared/api/gsp';

import { useScrollToActiveChat } from './hooks';

export const useSetFavoriteChat = () => {
  const { onClose, anchorEl } = useMenuContext();
  const { chatTopics, setChatTopics } = useParentHelperContext();
  const [addToFavorite] = usePutApiParentHelperTopicsFavouriteMutation();

  const scrollToActiveChat = useScrollToActiveChat();

  return useCallback(() => {
    if (!anchorEl?.id) return;

    const chatId = anchorEl?.id || null;
    const currentChat = chatTopics.find(chat => chat.chatId === chatId);

    if (!currentChat || !chatId) return;

    addToFavorite({
      inspiredGlobalStudyPlatformApiModelsParentHelperPutFavoriteTopicRequest: {
        chatId,
        isFavorite: !currentChat.isFavorite,
      },
    })
      .unwrap()
      .then(() => {
        const updatedChatTopics = [...chatTopics];
        const chatIndex = updatedChatTopics.findIndex(
          chat => chat.chatId === chatId,
        );

        if (chatIndex > -1) {
          updatedChatTopics.splice(chatIndex, 1, {
            ...currentChat,
            isFavorite: !currentChat.isFavorite,
          });
        }

        onClose();
        setChatTopics(updatedChatTopics.sort(sortChatsByDateAndFavorite));

        scrollToActiveChat();
      });
  }, [
    addToFavorite,
    anchorEl?.id,
    chatTopics,
    onClose,
    setChatTopics,
    scrollToActiveChat,
  ]);
};
